import React from 'react';
import ReactDOM from 'react-dom';
import Routes from 'components/Routes';
import Start from './components/Start';
import { GlobalStyle } from './styles';
import { BrowserRouter } from 'react-router-dom';
import Footer from './components/Footer';

const App = () => {
  return (
    <>
      <GlobalStyle />
      <BrowserRouter>
        <Start />
        <Routes />
        <Footer />
      </BrowserRouter>
    </>
  );
};
const root = document.createElement('div');
document.body.appendChild(root);

ReactDOM.render(<App />, root);

export default App;
